var render = function render(){var _vm=this,_c=_vm._self._c;return _c('up-device-alert',_vm._b({attrs:{"list":_vm.filteredUPList},on:{"reload":function($event){return _vm.$emit('reload')}}},'up-device-alert',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }